// extracted by mini-css-extract-plugin
module.exports = {"row":"Category_row__31CKc","text":"Category_text__1UKhz","image":"Category_image__2betg","title":"Category_title__3-jU_","category":"Category_category__N__3l"};